import CellActions from "Components/CellActions";
import React from "react";
import { useSelector } from "react-redux";
import { Button, Card, CardBody, CardTitle, Table } from "reactstrap";
import { WeighbillItem } from "types";

interface TableProps {
  data: WeighbillItem[];
  onAddItemClick: () => void;
  onDeleteItemClick: (index: number) => void;
  onEditItemClick: (item: WeighbillItem, index: number) => void;
}

export const WeighbillItemsTable = ({
  data,
  onAddItemClick,
  onDeleteItemClick,
  onEditItemClick,
}: TableProps) => {
  const defaultCurrency = useSelector(
    (state: any) => state.Login.default_currency
  );

  return (
    <Card>
      <CardBody>
        <CardTitle tag="h4">Weighbill Items</CardTitle>
        {/* Button Section */}
        <div className="d-flex justify-content-end mt-3">
          <Button
            color="success"
            className="w-10 me-1"
            onClick={onAddItemClick}
          >
            Add Item
          </Button>
        </div>
        {data && data.length > 0 ? (
          <div className="mt-4 mb-4">
            <div className="table-responsive">
              <Table className="table align-middle table-nowrap">
                <thead className="table-light">
                  <tr>
                    <th scope="col">Product</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Price</th>
                    <th scope="col">Sub Total</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center">
                          <h5 className="font-size-14 text-truncate mb-0">
                            {item.product?.name || item.product_name}
                          </h5>
                        </div>
                      </td>
                      <td>{item.quantity}</td>
                      <td>
                        {defaultCurrency} {Number(item.cost_price).toFixed(2)}
                      </td>
                      <td>
                        {defaultCurrency}{" "}
                        {Number(item.cost_price * item.quantity).toFixed(2)}
                      </td>
                      <td>
                        <td>
                          <CellActions
                            data={item}
                            onEdit={() => {
                              onEditItemClick(item, index);
                            }}
                            onDelete={() => onDeleteItemClick(index)}
                          />
                        </td>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4}>
                      <h6 className="m-0 text-end">Total:</h6>
                    </td>
                    <td className="text-end">
                      <strong>
                        {defaultCurrency}{" "}
                        {Number(
                          data.reduce(
                            (sum, item) =>
                              sum +
                              (item.cost_price || 0) * (item.quantity || 0),
                            0
                          )
                        ).toFixed(2)}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        ) : (
          <div className="text-center mt-4 mb-4">
            No items have been added yet.
          </div>
        )}
      </CardBody>
    </Card>
  );
};
